<template>
	<Modal v-model="show" title="客户经理项目人角色信息" :width="60">
		<Spin v-if="$globalSpin" size="large" fix></Spin>
		<Form ref="modelForm" :model="modelForm" :rules="ruleValidate" label-position="top" class="small-form">

			<Row :gutter="16">
				<Col span="6">
				<FormItem label="角色名称" prop="name">
					<Input v-model="modelForm.name"></Input>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="状态">
					<RadioGroup v-model="modelForm.recordStatus" type="button">
						<Radio v-for="item in statusSource" :key="item.val" :label="item.val">{{ item.label }}
						</Radio>
					</RadioGroup>
				</FormItem>
				</Col>
			</Row>
		</Form>
		<div slot="footer">
			<Button type="primary" @click="onSave">确认</Button>
			<Button type="error" @click="onCancel">取消</Button>
		</div>
	</Modal>
</template>

<script>
import {
    STATUS_YES,
    STATUS_NO,
    statusNewFormat
} from '@/libs/baseModelFormat';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';

import {
    roleSave,
    getRoleDetail
} from '@/api/modules/account-management/inspector-user-management';

export default {
    name: 'FinanceUserEdit',
    data() {
        return {
            show: false,
            uuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            modelForm: {
                roleUuid: '',
                name: '',
                type: '客户经理项目人',
                recordStatus: STATUS_YES
            },
            ruleValidate: {},
            statusSource: [],
            roleIdList: []
        };
    },
    mounted() {},
    methods: {
        showModal(uuid) {
            if (uuid == '') {
                this.uuid = '';
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.uuid = uuid;
            }
            this.init();
            this.show = true;
        },
        init() {
            this.statusSource = [];
            this.statusSource.push({
                val: STATUS_YES,
                label: statusNewFormat(STATUS_YES)
            });
            this.statusSource.push({
                val: STATUS_NO,
                label: statusNewFormat(STATUS_NO)
            });

            if (this.uuid != '') {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;

                getRoleDetail({
                    roleUuid: this.uuid
                }).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        const info = res.data.roleModel;
                        this.modelForm.roleUuid = info.roleUuid;
                        this.modelForm.name = info.name;
                        this.modelForm.type = info.type;
                        this.modelForm.recordStatus = info.recordStatus;
                    }
                }).catch(() => {
                    this.$hideGlobalSpin();
                });
            }
            else {
                this.$refs.modelForm.resetFields();
            }
        },
        onSave() {
            this.$refs.modelForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({
                    formEditMode: this.formEditMode
                }, this.modelForm);

                this.$showGlobalSpin();
                roleSave(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped>
</style>
